(() => {
	angular.module('main').directive('editContractModal', editContractModal);

	editContractModal.$inject = [];

	function editContractModal() {
		return {
			restrict: 'E',
			scope: {
				closeEditContract: '&',
				editableContract: '=',
				saveEditedContract: '&',
				isEditContractModalSpinnningWheelActive: '='
			},
			template: ` <section class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <form role="form">
                                        <div class="modal-header">
                                            <btn-close ng-click="closeEditContract()"></btn-close>
                                            <h3 class="modal-title">Edit Contract</h3>
                                        </div>
                                       
                                        <div class="modal-body">
                                            <div class="field-info">
                                               <h4 class="mt-0">Contract terms and conditions</h4>
                                                <sn-text-angular sn-model="editableContract.text" sn-name="editable_contract"
                                                                 sn-tools="[['bold', 'italics', 'underline'], ['link'], ['ul', 'ol'],[ 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull' ] ,['reminderTokens']]"></sn-text-angular>
                                            </div>
                                        </div>
                                        <div class="modal-footer modal-foot">
                                            <button type="submit" ng-click="saveEditedContract()" class="btn btn-success btn-lg" spinning-wheel is-spinning-wheel-active="isEditContractModalSpinnningWheelActive">Save contract</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
`,
			replace: true,
			transclude: true,
			link(scope) {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/editContractModal.js